var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04632 5.75203C4.11597 3.18355 6.62221 1.50756 9.4045 1.50013C12.4083 1.48208 15.0802 3.40531 16.0165 6.25947C16.9529 9.11364 15.9395 12.2459 13.5088 14.0107C11.078 15.7755 7.78598 15.7692 5.36201 13.9951L3.20951 16.1476C2.98989 16.367 2.63412 16.367 2.41451 16.1476C2.19516 15.928 2.19516 15.5722 2.41451 15.3526L4.507 13.2601C2.55243 11.28 1.97667 8.3205 3.04632 5.75203ZM11.145 6.03134C11.328 6.46922 11.7574 6.75316 12.232 6.75013C12.874 6.75013 13.3945 6.22966 13.3945 5.58763C13.3975 5.11305 13.1136 4.68366 12.6757 4.50065C12.2378 4.31763 11.7328 4.41725 11.3972 4.75284C11.0616 5.08842 10.962 5.59347 11.145 6.03134Z",
    fill: "#83888E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/Magnifier.dbb1d344b562233501495f59930bed02.svg";
export { ForwardRef as ReactComponent };